import ProductCard from "../elements/ProductCard";
import { AdviseLabels } from "../enums/MessageEnum";
import srcPanelesAdviseScreenshot from "../assets/img/captura_paneles_advise.png"
import srcAdviseConvenioMarco from "../assets/img/cm/conveniomarcobase.png"
import srcConvenioMarco from "../assets/img/mercadopublico_convenio.jpg"
import Title from "../elements/Title";
import {useEffect, useState} from "react";
import panelesIconos from "../assets/img/products/panelesSolares.png"
import convenioMarco from "../assets/img/products/Logo_mercadopublico.png"
import advisecm from "../assets/img/products/advisecm.png"

import ProductSelector from "../elements/ProductSelector";

export default function Products(props){

    const [selected, setSelected] = useState(0)
    const [transitionClass, setTransitionClass] = useState('')
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);


    const products = [
        {
            name: "Licitación 2239-19-LR23",
            title: "Convenio Marco",
            description: "En julio de 2024, participamos en la licitación del Nuevo Convenio Marco de Servicios de Desarrollo y Mantención de Software, donde Advise resultó adjudicada. Nuestra empresa quedó activa en dos categorías de servicios: Desarrollo y Mantención de Software y Servicios Profesionales TI.",
            src: srcConvenioMarco,
            link: null,
            icon: convenioMarco,
        }
        ,
        {
            name: "Sistema Integral Gestión Generadores de Energías Renovable",
            title: AdviseLabels.PRODUCTS_PANELES_TITLE_ADVISE,
            description: AdviseLabels.PRODUCTS_PANELES_TITLE_DESCRIPTION,
            src: srcPanelesAdviseScreenshot,
            link: "/SiGGER360",
            icon: panelesIconos,
        },
        {
            name: "Marco Software Analyzer",
            title: AdviseLabels.PRODUCTS_CONVENIO_MARCO_TITLE,
            description: AdviseLabels.PRODUCTS_CONVENIO_MARCO_DESCRIPTION,
            src: srcAdviseConvenioMarco,
            link: "/MSA",
            icon: advisecm
        }
    ]
    useEffect(() => {
        if (initialLoad) {
            setTransitionClass('initial-slide-in');
            setTimeout(() => {
                setTransitionClass('');
                setInitialLoad(false);
            }, 500);
        }
    }, [initialLoad]);
    function handleChangeIndex(index) {
        if (isTransitioning || index === selected) return; // Si una transición está en curso, salir

        setIsTransitioning(true); // Bloquear otras transiciones
        setTransitionClass('slide-out-right');
        setTimeout(() => {
            setSelected(index);
            setTransitionClass('slide-in-right');
            setTimeout(() => {
                setTransitionClass('');
                setIsTransitioning(false); // Permitir nuevas transiciones
            }, 500); // Duración de la animación de entrada
        }, 500); // Duración de la animación de salida
    }



    return (
        <div id='products' className="information-subsection bg-gray-100">
            <Title title={AdviseLabels.PRODUCTS_TITLE} />
            <div className="product-selector-base-container">
                <div className="product-selector-container">
                    {products.map((product, index) => (
                        <ProductSelector
                            title={product.title}
                            name={product.name}
                            src={product.icon}
                            handleClick={() => handleChangeIndex(index)}
                            index={index}
                            selected={selected}
                            key={index}
                            isLargeScreen={props.isLargeScreen}
                        />
                    ))}
                </div>
            </div>
            <div className="products-slider-container">
                <div className={`product-card ${transitionClass}`}>
                    <div className="relative min-h-56 overflow-hidden rounded-lg" style={{ minHeight: "fit-content" }}>
                        <ProductCard
                            name={products[selected].name}
                            description={products[selected].description}
                            src={products[selected].src}
                            link={products[selected].link}
                            key={products[selected].name}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}